// components/ProspectionHero.jsx
import React from "react";
import {
  FaBullhorn,
  FaEnvelopeOpenText,
  FaPaperPlane,
  FaShieldAlt,
  FaUsers,
} from "react-icons/fa";
import ProspectionTabs from "./ProspectionTabs";

export default function ProspectionHero({
  activeTab,
  setActiveTab,
  kpisAll,
  pagination,
  loading,
  pageKpis,
}) {
  return (
    <div className="relative overflow-hidden rounded-3xl bg-slate-950 text-white shadow-xl">
      <div className="absolute inset-0 opacity-70 bg-[radial-gradient(circle_at_top_left,#2563eb,transparent_32%),radial-gradient(circle_at_top_right,#9333ea,transparent_28%),radial-gradient(circle_at_bottom,#0f766e,transparent_30%)]" />

      <div className="relative p-6 lg:p-8">
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-6">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1 text-xs text-white/85">
              <FaBullhorn />
              CRM & campagnes email
            </div>

            <h1 className="mt-4 text-3xl lg:text-4xl font-bold tracking-tight">
              Prospection & Mailing
            </h1>

            <p className="mt-3 max-w-3xl text-sm lg:text-base text-white/78 leading-relaxed">
              Gérez vos prospects, créez des modèles enrichis, préparez vos
              campagnes, envoyez progressivement et suivez les désinscriptions.
            </p>

            <div className="mt-5 flex flex-wrap gap-2 text-xs">
              <Badge icon={<FaShieldAlt />} text="Désinscrits exclus" />
              <Badge icon={<FaEnvelopeOpenText />} text="Tests avant envoi" />
              <Badge icon={<FaPaperPlane />} text="Envoi progressif" />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 xl:min-w-[520px]">
            <HeroMetric
              icon={<FaUsers />}
              label="Total filtré"
              value={kpisAll?.total || 0}
            />
            <HeroMetric
              label="Prospects"
              value={kpisAll?.prospects || 0}
            />
            <HeroMetric label="Intérêt" value={kpisAll?.interest || 0} />
            <HeroMetric label="Clients" value={kpisAll?.clients || 0} />
          </div>
        </div>

        <div className="mt-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <ProspectionTabs activeTab={activeTab} setActiveTab={setActiveTab} />

          <div className="flex flex-wrap items-center gap-2 text-xs text-white/75">
            <span className="rounded-full bg-white/10 border border-white/15 px-3 py-1">
              Page {pagination?.page || 1}/{pagination?.pages || 1}
            </span>

            <span className="rounded-full bg-white/10 border border-white/15 px-3 py-1">
              Lignes page : {pageKpis?.pageCount || 0}
            </span>

            {pageKpis?.unsubDetected > 0 && (
              <span className="rounded-full bg-rose-500/20 border border-rose-300/30 px-3 py-1 text-rose-100">
                {pageKpis.unsubDetected} désinscrit(s) détecté(s)
              </span>
            )}

            {loading && (
              <span className="rounded-full bg-white/10 border border-white/15 px-3 py-1">
                Chargement…
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Badge({ icon, text }) {
  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1">
      {icon}
      {text}
    </span>
  );
}

function HeroMetric({ icon, label, value }) {
  return (
    <div className="rounded-2xl bg-white/10 border border-white/15 p-4 backdrop-blur-sm">
      <div className="flex items-center justify-between gap-2">
        <div className="text-xs text-white/70">{label}</div>
        {icon ? <div className="text-white/70">{icon}</div> : null}
      </div>
      <div className="mt-2 text-2xl font-bold tabular-nums">{value}</div>
    </div>
  );
}